import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connectWithStore from '../../hocs/connectWithStore';
import GameResult from './game_result';
import {
  setGames,
  setLoading,
} from '../standings/standings_actions';
import { buildLocalizedUrl } from '../../utils/locale';

class LatestGames extends Component {
  constructor(props) {
    super(props);
    props.setGames(props.init.games);
  }

  componentDidUpdate(prevProps) {
    const { currentSeason } = this.props;
    if (prevProps.currentSeason && currentSeason !== prevProps.currentSeason) {
      this.fetchGames(currentSeason);
    }
  }

  fetchGames = async (seasonId) => {
    const { setLoading, setGames } = this.props;
    setLoading(true);
    try {
      const response = await fetch(`${buildLocalizedUrl('api/latest_games')}?season_id=${seasonId}`);
      const data = await response.json();
      setGames(data);
    } catch (error) {
      console.error('Error fetching games:', error);
    } finally {
      setLoading(false);
    }
  };

  render() {
    const {
      init,
      games,
      t_controls,
      loading,
      currentSeason
    } = this.props;

    const filteredGames = games || init.games;
    return (
      <div className="latest-games-container">
        <article className="heading-component">
          <div className="heading-component-inner">
            <h5 className="heading-component-title">
              {t_controls.title}
            </h5>
          </div>
        </article>
        {loading ? (
          <div className="text-center p-4">{t_controls.loading}</div>
        ) : (
          <div className="game-results">
            {filteredGames.map((game) => (
              <GameResult key={game.id} game={game} t_controls={t_controls} />
            ))}
          </div>
        )}
      </div>
    );
  }
};

LatestGames.propTypes = {
  init: PropTypes.shape({
    games: PropTypes.array.isRequired,
  }),
  t_controls: PropTypes.object.isRequired,
  games: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  currentSeason: PropTypes.number,
};

const mapStateToProps = state => ({
  games: state.standings.games,
  loading: state.standings.loading,
  currentSeason: state.standings.currentSeason
});

const mapDispatchToProps = {
  setGames,
  setLoading
};

export default connectWithStore(
  mapStateToProps,
  mapDispatchToProps
)(LatestGames);